export const SET_RESPONSE = 'APP_BACKGROUNDJOBS_SET_RESPONSE';
export const SET_TYPES = 'APP_BACKGROUNDJOBS_SET_TYPES';
export const LOADING = 'APP_BACKGROUNDJOBS_LOADING';
export const ERROR = 'APP_BACKGROUNDJOBS_ERROR';
export const SET_HISTORY_TYPE = 'SET_HISTORY_TYPE';